import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmSignUp } from "aws-amplify/auth";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const emailFromURL =
    searchParams.get("email") || localStorage.getItem("pendingEmail") || "";
  const [email, setEmail] = useState(emailFromURL);
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [verified, setVerified] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (verified) return;
    setMsg("");
    setErr("");
    setIsVerifying(true);

    try {
      await confirmSignUp({
        username: email.toLowerCase(),
        confirmationCode: code,
      });

      localStorage.removeItem("pendingEmail");
      setVerified(true);
      setMsg(
        "Email verified successfully! You will receive an email after administrator approval."
      );

      // Redirect after short delay
      setTimeout(() => {
        navigate("/login");
      }, 4000);
    } catch (error) {
      console.error("Verification error:", error);

      if (error.name === "CodeMismatchException") {
        setErr("Invalid verification code. Please check your email and try again.");
      } else if (error.name === "ExpiredCodeException") {
        setErr("This code has expired. Please request a new one.");
      } else if (error.name === "NotAuthorizedException") {
        setErr("Your email is already verified. You can sign in now.");
      } else if (error.name === "UserNotFoundException") {
        setErr("No account found for this email. Please request an account.");
      } else {
        setErr(error.message || "Verification failed. Please try again.");
      }
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <img
          src="infauxtech_logo_rectangle.png"
          alt="Media Forensics Hub"
          className="w-32 mx-auto mb-4"
        />
        <h2 className="text-2xl font-bold text-purple-800 mb-2">
          Verify Your Email
        </h2>
        <p className="text-gray-600 mb-4 text-sm">
          Enter the verification code sent to your email.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            disabled={!!emailFromURL}
            required
          />
          <input
            type="text"
            placeholder="Verification code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            required
          />
          <button
            type="submit"
            disabled={isVerifying || verified}
            className={`w-full font-semibold py-2 rounded-lg text-white ${
              verified
                ? "bg-green-600 opacity-70 cursor-not-allowed"
                : "bg-purple-700 hover:bg-purple-800"
            }`}
          >
            {verified
              ? "Verified"
              : isVerifying
              ? "Verifying..."
              : "Verify Email"}
          </button>
        </form>

        {msg && (
          <div className="mt-6 text-center">
            <p className="text-green-600 font-medium">{msg}</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-4 text-purple-700 font-semibold hover:underline"
            >
              Sign in here →
            </button>
          </div>
        )}

        {err && (
          <p className="mt-4 text-red-600 text-center font-medium">{err}</p>
        )}
      </div>
    </div>
  );
}
